<template>
  <div class="all">
    <div class="header">
      <h1>CP / MOTION<br>商業攝影 / 動態影像</h1>
    </div>
    <section class="section1" id="section1">
      <div class="custom-container">
        <ul class="type-filter">
          <li class="type" v-for="item in categories" :key="item.id" :class="[item.trans.name===filterOption? 'is-checked' : '']" @click="filterCategories(item.trans.name)">{{item.trans.name}}&nbsp;&nbsp;/</li>
        </ul>
        <isotope ref="cpt" id="root_isotope1" class="row custom-row" :item-selector="'custom-grid'" :list="list" :options='option' @sort="sortOption=arguments[0]" @layout="currentLayout=arguments[0]">
          <div class="col-md-4 col-sm-6" v-for="element,index in list" :class='[element.category]'  :key="index">
            <div class="photographic-card" @click="openDetail(element)">
              <div class="photographic-img" :style="{'background-image': 'url(' + element.trans.image_path + ')'}">
                <div class="cover" v-if="element.trans.url == null">
                  <h1 class="text">{{element.category.trans.name}}</h1>
                </div>
                <div class="film-cover" v-if="element.trans.url != null">
                  <img src="/static/images/photographic/play-video.svg" alt="" class="play-icon">
                </div>
              </div>
            </div>
          </div>
        </isotope>
        <transition name="zoom" mode="out-in">
          <div class="empty_msg" v-if="empty">此類別尚無作品。</div>
        </transition>
        <VideoModal v-if="videoZoom" v-bind:cardData="cardData" @closeZoom="close"></VideoModal>
      </div>
    </section>
  </div>
</template>

<script>
  import navigation from './navigation.vue';
  import isotope from 'vueisotope'
  import VideoModal from '@/components/VideoModal.vue'
  export default {
  name: 'Photographic',
    components:{
      navigation,
      isotope,
      VideoModal
    },
    data() {
      return {
        empty:false,
        categories:[],
        list: [],
        filterOption: "",
        option: {
          itemSelector: ".custom-grid",
          getFilterData: {
            "category": function(el) {
              if (this.$parent) {
                return el.category.trans.name === this.$parent.filterOption;
              }
              return false;
            },
          },
        },
        cardData:[],
        videoZoom: false,
      }
    },
    methods:{
      filter: function(key) {
        this.$refs.cpt.filter(key);
        var filter_item = this.$refs.cpt.iso.filteredItems.length
        if(filter_item <= 0){
          this.empty = true;
        }else{
          this.empty = false;
        }
      },
      filterCategories(name) {
        this.filterOption = name;
        this.filter('category');
      },
      openDetail(element){
        if(element.trans.url != null){
          this.videoZoom = true;
          this.cardData = element;
        }
      },
      close() {
        this.videoZoom = false;
        document.querySelector('body').style.overflow = "auto"
      },
      CallCategoriesApi(){
        let vm = this;
        vm.axios({
          method: "get",
          url: process.env.VUE_API_URL + "v1/media-category/video",
        })
        .then(function (response) {
          let res = response.data.data;
          vm.categories = res;
          vm.filterCategories(vm.categories[0].trans.name);
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      CallPhotographicApi(){
        let vm = this;
        vm.axios({
          method: "get",
          url: process.env.VUE_API_URL + "v1/media/video",
        })
        .then(function (response) {
          let res = response.data.data;
          vm.list = res
        })
        .catch(function (error) {
          console.log(error)
        })
      },
    },
    mounted(){
      this.CallCategoriesApi();
      this.CallPhotographicApi();
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/photographic/header.scss';
  @import 'src/assets/scss/photographic/section1.scss';
</style>


// WEBPACK FOOTER //
// src/components/Photographic.vue